import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { Box, Flex, Text } from "rebass";

import { IBookInfo } from "../../../../store/modules/library/IBookInfo";
import { getRate } from "../../../../store/modules/audio/selectors";

import { Progress } from "../../Progress";
import { RecordIcon } from "../../RecordIcon";
import { StyledLink } from "./StyledLink";
import { SpinnerSVG } from "../../svg/SpinnerSVG";

import { rateToValue } from "../../../../utils/converSpeed";

interface IProps {
  record: IBookInfo;
}

export const RecordLink: React.FC<IProps> = (
  {
    record: {
      id,
      title,
      coverImagePath,
      wordCount,
      progress = 20,
      isProcessing,
    },
  }
) => {
  const rate = useSelector(getRate);
  const time = useMemo(() => (
    (wordCount / rateToValue(rate)).toFixed(0)
  ), [rate, wordCount]);

  return (
    <StyledLink to={`/record/${id}`}>
      <RecordIcon
        variant="md"
        title={title}
        coverImagePath={coverImagePath}
      />

      <Box
        flex="1"
        ml="17px"
        mr="5px"
        css="overflow: hidden;"
      >
        <Text
          width={1}
          mb="5px"
          fontSize="18px"
          fontWeight="bold"
          color="zodiac"
          css="min-height: 21px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
        >
          {title}
        </Text>

        <Flex alignItems="center" width={1}>
          <Text
            fontSize="14px"
            color="#7b80aa"
          >
            {isProcessing ? "Loading..." : `~ ${time}min`}
          </Text>

          {
            !isProcessing && (
              <Box
                width="100px"
                ml="auto"
                mr="11px"
                css="overflow: hidden;"
              >
                <Progress value={progress} />
              </Box>
            )
          }
        </Flex>
      </Box>

      {
        isProcessing && (
          <Box mx="15px" color="sp-blue">
            <SpinnerSVG />
          </Box>
        )
      }
    </StyledLink>
  );
};
